export default __webpack_public_path__ + "static/media/Mech_Depot_LE.8e073bcd.jpg";